import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ContactPage() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    document.title = 'Contact Us | AllChinaBuy Spreadsheet Hub';
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('company_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      return;
    }
    setStatus('submitting');
    setTimeout(() => {
      setStatus('success');
      form.reset();
    }, 1500);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <div className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-16">
          <div className="max-w-2xl mx-auto">
            <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-4">Contact Us</h1>
            <p className="text-foreground-600 mb-8 leading-relaxed">
              Have questions, suggestions, or feedback? We would love to hear from you. Fill out the form below and we will get back to you as soon as possible.
            </p>

            <form onSubmit={handleSubmit} className="space-y-5">
              {/* Honeypot */}
              <div className="hp-field" style={{ position: 'absolute', left: '-9999px' }}>
                <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground-800 mb-1.5">Name</label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-3 bg-background-50 border border-background-200/70 rounded-md text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent"
                  placeholder="Your name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-800 mb-1.5">Email</label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 bg-background-50 border border-background-200/70 rounded-md text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent"
                  placeholder="your@email.com"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-800 mb-1.5">Subject</label>
                <input
                  type="text"
                  name="subject"
                  required
                  className="w-full px-4 py-3 bg-background-50 border border-background-200/70 rounded-md text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent"
                  placeholder="What is this about?"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground-800 mb-1.5">Message</label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 bg-background-50 border border-background-200/70 rounded-md text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent resize-y"
                  placeholder="Your message (max 500 characters)"
                />
                <p className="mt-1 text-xs text-foreground-500">Maximum 500 characters</p>
              </div>

              <button
                type="submit"
                disabled={status === 'submitting'}
                className="w-full px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors disabled:opacity-60"
              >
                {status === 'submitting' ? 'Sending...' : 'Send Message'}
              </button>

              {status === 'success' && (
                <div className="p-4 bg-accent-50 border border-accent-200 rounded-md text-sm text-accent-800">
                  Thank you! Your message has been received. We will get back to you soon.
                </div>
              )}
              {status === 'error' && errorMsg && (
                <div className="p-4 bg-secondary-50 border border-secondary-200 rounded-md text-sm text-secondary-800">
                  {errorMsg}
                </div>
              )}
            </form>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}